import { Validator } from 'vee-validate';

Validator.extend('isYear', {
    getMessage: field => `The ${field} is not in the correct format (YYYY).`,
    validate: value => (value.match(/\d{4}/) ? true : false)
});

Validator.extend('truthy', {
    getMessage: field => `No value has been selected for ${field}.`,
    validate: value => {
        if (typeof value === 'string') {
            return value === 'false' ? false : true;
        } else {
            return !!value;
        }
    }
});

Validator.extend('name', {
    getMessage: field =>
        `The ${field} contains invalid characters, use alphabet characters and dashes only.`,
    validate: value => (value.match(/^[A-Za-zÀ-ÿ\- ]+$/) ? true : false)
});

Validator.extend('nickname', {
    getMessage: field =>
        `The Avatar Name contains invalid characters, use alphanumeric characters, spaces and dashes only.`,
    validate: value => (value.match(/^[A-Za-zÀ-ÿ\-\ \d]+$/) ? true : false)
});

Validator.extend('radioTabs', {
    getMessage: field => `No value has been selected for ${field}.`,
    validate: value => {
        if (value !== '') {
            return true;
        } else {
            return false;
        }
    }
});

// This is just a placeholder to silence an error in the PhoneInput. The real validator is in the PhoneInput component.
Validator.extend('mobileIsValid', {
    getMessage: () => ``,
    validate: () => true
});



// WEBPACK FOOTER //
// ./resources/assets/js/setup/validators.js